import {Link} from "react-router-dom"

export const AdminDropdownMenu = ({role}) => {
    const isAdmin = ["Enterprise Admin"].includes(role)
    return (
        <div className="d-flex menu menu-sub menu-sub-dropdown menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px">
            <div className="menu-item px-3">
                <div className="menu-content d-flex align-items-center px-3">
                    <div className="d-flex flex-column">
                        <div className="fw-bold d-flex align-items-center fs-5">Administrator</div>
                    </div>
                </div>
            </div>
            <div className="separator my-2"></div>

            {isAdmin && (
                <div className="menu-item px-5">
                    <Link to="/admin/organization" className="menu-link px-5">
                        <span className="menu-icon">
                            <i className="fas fa-sitemap fs-2 text-primary"></i>
                        </span>
                        <span>Organizations</span>
                    </Link>
                </div>
            )}
            <div className="menu-item px-5">
                <Link to="/admin/users" className="menu-link px-5">
                    <span className="menu-icon">
                        <i className="fas fa-users fs-2 text-primary"></i>
                    </span>
                    <span>User Accounts</span>
                </Link>
            </div>
            {isAdmin && window.__APP_CONFIG__?.ENV && window.__APP_CONFIG__.ENV !== "prod" && (
                <div className="menu-item px-5">
                    <Link to="/adopt-persona" className="menu-link px-5">
                        <span className="menu-icon">
                            <i className="fas fa-user-secret fs-2 text-primary"></i>
                        </span>
                        <span>Adopt Persona</span>
                    </Link>
                </div>
            )}
        </div>
    )
}

export default AdminDropdownMenu
